import { getDiscountMinVolume } from '~~/helpers/voumeDiscounts/getDiscountMinVolume';
import type { CartDiscountRaw, VolumeDiscount } from '~~/types/discounts';

export const parseVolumeDiscounts = (rawDiscounts?: CartDiscountRaw[]): VolumeDiscount[] => {

  return rawDiscounts?.flatMap(discount => {

    const volume = getDiscountMinVolume(discount.target?.predicate);

    if (!volume) {

      return [];
    
    }

    const discountPercentage = (discount.value?.permyriad || 0) / 100;

    if (!discountPercentage) {

      return [];
    
    }

    return [{ volume, discountPercentage }];
  
  }) || [];

};
